import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';

import { ROUTES } from './app.routes';
import { AppComponent } from './app.component';

import { CoreModule } from './core/core.module';
import { LayoutsModule } from './common/layouts/layouts.module';
import { AppLoadModule } from './app-load/app-load.module';
import { PeopleModule } from './people/people.module';
import { AdminModule } from './admin/admin.module';
import { MessagesModule } from './messages/messages.module';
import { GivingModule } from './giving/giving.module';
import { InterestsModule } from './interests/interests.module';
import { InvolvementModule } from './involvement/involvement.module';
import { MemberPortalModule } from './member-portal/member-portal.module';
import { ExecutiveModule } from './executive/executive.module';
import { CommitteesModule } from './committees/committees.module';
import { InvoicesModule } from './invoices/invoices.module';

@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserModule,
        FormsModule,
        LayoutsModule,
        AppLoadModule,
        CoreModule,
        RouterModule.forRoot(ROUTES),
        PeopleModule,
        MessagesModule,
        ExecutiveModule,
        GivingModule,
        InterestsModule,
        InvolvementModule,
        MemberPortalModule,
        AdminModule,
        CommitteesModule,
        InvoicesModule
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
